import { Action } from "redux";
import { LegalNavId } from "../types/index.js";
import { isActionType } from "./utils.js";

const ActionTypeKeys = ["TOGGLE_LEGAL_NAV"] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type ToggleLegalNav = ActionBase<"TOGGLE_LEGAL_NAV"> & {
  legalNavId: LegalNavId | undefined;
};

export type LegalNavAction = ToggleLegalNav;

export const isLegalNavAction = (action: Action): action is LegalNavAction =>
  isActionType(action, ActionTypeKeys);

export const toggleLegalNav = (
  legalNavId: LegalNavId | undefined,
): ToggleLegalNav => ({ type: "TOGGLE_LEGAL_NAV", legalNavId });
